var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button",attrs:{"href":_vm.href,"target":"_blank"}},[_c('span',[_vm._v(_vm._s(_vm.label))]),_c('img',{attrs:{"alt":"箭头图标","src":require("../../assets/right-arrow.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }